import React, { Component } from 'react';
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import DraggerIcon from "../icons/draggericon";
import CatEditIcon from "../icons/catediticon";
import TextField from "../component/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "../component/loader";
import PlusIcon from '../icons/plusicon';

let sub;

class FilmDevice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      name: "",
      description: "",
      loaderFlag: false,
      isDraggable: false,
      changeDeviceTitleName: false,
      getAllDeviceDetails: [],
      getAllDeviceDocs: [],
      id: "",
      isDraggable: false,
      isEdited: false
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        devicename: {  // name the rule
          message: 'Device Name is required.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
          },
          required: true  // optional
        },
        description: {  // name the rule
          message: 'Device Description is required.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
          },
          required: true  // optional
        },
      }
    })
    this.apiserve = new service();
  }
  AddCategory = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      name: "",
      description: "",
      isEdited: true
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      name: "",
      description: "",
      changeDeviceTitleName: false,
      id: '',
      isEdited: false
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllGenre();
    this.getgenre();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getgenre = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|deviceType|getRefValue":
          this.setState(
            {
              getAllDeviceDetails: response.data,
              getAllDeviceDocs: response.data.docs,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
            }
          );
          break;
        case "film|deviceType|add":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
              },
              this.setState({
                loaderFlag: false,
                name: "",
                description: "",
                changeDeviceTitleName: false,
              }),
              this.apiserve.success("Device created successful.")
            );
          }
          this.getAllGenre();
          break;
        case "film|deviceType|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
                changeDeviceTitleName: false,
              },
              this.setState({ loaderFlag: false }),

              this.apiserve.success("Device updated Successful.")
            );
          }
          this.getAllGenre();
          break;
        case "film|deviceType|remove":
          this.getAllGenre();
          break;
        case "film|deviceType|changeOrder":
          break;
      }
    });
  };

  getAllGenre = () => {
    this.apiserve.sendevent("film|deviceType|getRefValue", {});
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeDeviceTitleName) {
        let updateGenre = {
          name: this.state.name,
          description: this.state.description,
          deviceTypeId: this.state.id,
        };
        this.apiserve.sendevent("film|deviceType|update", updateGenre);
      } else {
        let data = {
          name: this.state.name,
          description: this.state.description,
        };
        this.apiserve.sendevent("film|deviceType|add", data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editGenreUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeDeviceTitleName: true,
      name: item.name,
      description: item.description,
      id: item._id,
      isEdited: false
    });
  };

  deleteGenreUser = async (item) => {
    swal({
      // title: "Are you sure you want to delete this record?",
      text: "Are you sure you want to delete this record?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Your record has been deleted!", {
          icon: "success",
        });
        let data = {
          deviceTypeId: item._id,
        };
        this.apiserve.sendevent("film|deviceType|remove", data);
      } else {
        // swal("Your record is safe!");
      }
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllDeviceDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        deviceTypeId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("film|deviceType|changeOrder", data);
    this.setState({ getAllDeviceDocs: arr });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  render() {
    const { getAllDeviceDocs, changeDeviceTitleName } = this.state;
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            <li className="active">
              <p className="uppercase text_left">
                <div>NEW FRONTIER</div>
                {/* <span onClick={() => this.props.history.push('/newfrontierdevice')}><PlusIcon /></span> */}
              </p>
            </li>
          </ul>
          <div className="cat_outer_content">
            <div className="category_add_edit">
              <div className="category_header relative">
                <p>Devices </p>
                <span className="add_icon d_flex" onClick={this.AddCategory}>
                  <FpgPlusIcon
                    width="16"
                    height="16"
                    color="#ffffff"
                    stroke="#4F4F4F"
                  />
                </span>
              </div>
              <div className="list_wrap">
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <ul {...provided.droppableProps} ref={provided.innerRef}>
                        {getAllDeviceDocs.map((item, index) => (
                          <Draggable
                            key={item._id}
                            draggableId={item._id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <li
                                className="pointer d_flex d_flex_align_center"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <span className="cat_drag d_flex">
                                  <DraggerIcon />
                                </span>
                                <p className="cat_name">{item.name}</p>
                                <div className="action d_flex d_flex_align_center">
                                  <span
                                    className="cat_edit pointer"
                                    onClick={() => this.editGenreUser(item)}
                                  >
                                    <CatEditIcon />
                                  </span>
                                  <span
                                    className="remove_cat pointer"
                                    onClick={() => this.deleteGenreUser(item)}
                                  >
                                    <FpgMinusIcon
                                      width="16"
                                      height="16"
                                      color="#4F4F4F"
                                    />
                                  </span>
                                </div>
                              </li>
                            )}
                          </Draggable>
                        ))}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </div>
          <div
            className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
          >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner">
              <p className="cat_title text_center">
                {changeDeviceTitleName ? "Edit Device" : "Device"}
              </p>
              <form>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Device Name"
                    name="name"
                    value={this.state.name}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Device Name",
                      this.state.name,
                      "devicename|required"
                    )}
                  />
                </div>
                <div className="field_row horizontal_field d_flex">
                  <label>Device Description</label>
                  <div className="textarea_wrap">
                    <textarea
                      type="text"
                      rows="12"
                      name="description"
                      value={this.state.description}
                      onChange={this.onInputChange}
                    ></textarea>
                    <span style={{ color: "red" }}>
                      {this.validator.message(
                        "Device Description",
                        this.state.description,
                        "description|required"
                      )}
                    </span>
                  </div>
                </div>
                {/* <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Eventive ID"
                    name="eventiveId"
                    value={this.state.eventiveId}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message(
                      "Eventive ID",
                      this.state.eventiveId,
                      "required"
                    )}
                  />
                </div> */}
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.CloseModal}>
                    CANCEL
                  </button>
                    <button
                      className={this.state.changeDeviceTitleName && !this.state.isEdited ? "disabled" : "active"}
                      disabled={this.state.changeDeviceTitleName && !this.state.isEdited}
                      onClick={(e) => this.submitFn(e)}
                    >
                      SAVE
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    )
  }
}

export default FilmDevice;
